// extracted by mini-css-extract-plugin
export default {"container":"Table_container__4Ksbd","table":"Table_table__LK7nF","pagination":"Table_pagination__Pzy-F","table-container":"Table_table-container__plGpJ"};